export default __webpack_public_path__ + "static/media/australia.c9c65d0e.svg";